const modals = document.querySelectorAll('[a11y]');
const modalToggles = document.querySelectorAll('[data-a11y-toggle]');

console.log({A11yDialog})

window.announce = (message) => {
    let announcementDiv = document.getElementById("a11y-announcements");
    announcementDiv.innerHTML = message;
    announcementDiv.setAttribute("aria-live", "assertive");
    announcementDiv.setAttribute("aria-atomic", "true");
    announcementDiv.setAttribute("role", "alert");
    setTimeout(() => {
        announcementDiv.setAttribute("aria-live", "off");
        announcementDiv.innerHTML = "";
    }, 1000);
};

window.dialogs = {};
//create a new A11yDialog instance for each modal
modals.forEach(modal => {
    const dialog = new A11yDialog(modal);
    dialogs[modal.getAttribute('id')] = dialog;
    //on hide, remove the active class from the modal-toggle
    dialog.on('hide', () => {
        console.log("Modal hide");
        modal.classList.remove('active');
        modalToggles.forEach(toggle => {
            if (toggle.getAttribute('data-a11y-toggle') === modal.getAttribute('id')) {
                toggle.classList.remove('active');
            }
        });
        document.body.classList.remove('open-modal');
        announce("Modal closed");
    });
    //on show, add the active class to the modal-toggle
    dialog.on('show', () => {
        console.log("Modal show");
        const id = modal.getAttribute('id');
        modal.classList.add('active');
        modalToggles.forEach(toggle => {
            if (toggle.getAttribute('data-a11y-toggle') === id) {
                toggle.classList.add('active');
            }
        });
        document.body.classList.add('open-modal');
        announce(`Opened ${id}`);
    });
});




//modalToggleHandler: get the attr "data-modal-toggle" and find the .modal with matching data-modal attribute

const closeModal = (modal) => {
    //if no modal is passed, close all modals
    if (!modal) {
        modals.forEach(modal => {
            const m = modal.getAttribute('id');
            dialogs[m].hide();
        });
    }
    else {
        const m = modal.getAttribute('id');
        dialogs[m].hide();
    }
    
    document.body.classList.remove('id');

    document.body.removeAttribute('id');

}

const modalToggleHandler = (e) => {
    e.stopPropagation();
    const modalToggle = e.target.closest('[data-a11y-toggle]');
    const modalId = modalToggle.getAttribute('data-a11y-toggle');
    const dialog = dialogs[modalId];
    const isActive = dialog.shown;

    //  remove active from all active modals
     document.querySelectorAll("[a11y]").forEach(modal => {
        let m = modal.getAttribute('id');
        dialogs[m].hide();
    });


    if(isActive) {
        //if the modal is already active, close it
        dialog.hide();
    } else {
        //if the modal is not active, open it
        dialog.show();
    }
    
    // //add open-modal attribute to body
    // document.body.classList.toggle('open-modal');
    // if(!isActive) {
    //     document.body.setAttribute('data-modal-open', modalId);
    // } else {
    //     document.body.removeAttribute('data-modal-open');
    // }
}

window.handlers = {
    modalToggleHandler
}

modalToggles.forEach(toggle => {
    toggle.addEventListener('click', modalToggleHandler);
});

//if user clicks "close-modal" class, find the containing .modal and close it
document.body.addEventListener('click', (e) => {
    if (document.body.classList.contains("open-modal") && !e.target.closest('.modal')) {
        closeModal();
        console.log("clicked outside of open modal")
        e.preventDefault();
    }
    if (e.target.classList.contains('close-modal')) {
        const modal = e.target.closest('.modal');
        closeModal(modal);
    }
    //if we don't click inside a modal, close all modals
    
});

// on click .nav-links a, dialogs["menu-wrapper"].hide()
document.querySelectorAll('.nav-links a').forEach(link => {
    link.addEventListener('click', (e) => {
        if (document.body.classList.contains("open-modal")) {
            closeModal();
            console.log("clicked outside of open modal")

        }
    });
});

//on click escape, close all modals

document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        closeModal();
    }
});

// // if user clicks outside of the modal, close it
// document.body.addEventListener('click', (e) => {
//     if (!e.target.closest('modal')) {
//         closeModal();
//     }
// });

document.querySelectorAll("[data-a11y-hide]").forEach((el) => {
    el.addEventListener('click', (e) => {
        const modal = e.target.closest('.modal');
        closeModal(modal);
    });
});

window.toggleModal = (modalId) => {
    dialogs[modalId].shown ? dialogs[modalId].hide() : dialogs[modalId].show();
}

//on document click, check if body has data-modal-open attribute and there's no a11y ancestor, close open modal
document.body.addEventListener('click', (e) => {
    if (document.body.hasAttribute('data-modal-open') && !e.target.closest('[a11y]')) {
        closeModal();
    }
});

// //if data-modal-open="cart" is set, turn it off on scroll and hide modal
// document.body.addEventListener('wheel', (e) => {
//     if (dialogs["cart-drawer-wrapper"].shown) {
//         console.log(e)
//         // closeModal();
//         dialogs["cart-drawer-wrapper"].hide();
//     }
// });

//if cart-open query param is set, open the cart modal
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('cart-open')) {
    const cartOpen = urlParams.get('cart-open');
    if (cartOpen !== null) {
        dialogs["cart-drawer-wrapper"].show();
        document.body.classList.add('open-modal');
    }
}